module.exports = __webpack_public_path__ + "593a3d53/img/archive-icon.0a6a9de3.svg";